export const chatTypes = {
    CREATE_CONVERSATION_REQUEST: "CREATE_CONVERSATION_REQUEST",
    CREATE_CONVERSATION_SUCCESS: "CREATE_CONVERSATION_SUCCESS",
    CREATE_CONVERSATION_FAILURE: "CREATE_CONVERSATION_FAILURE",
    FETCH_CONVERSATION_REQUEST: "FETCH_CONVERSATION_REQUEST",
    FETCH_CONVERSATION_SUCCESS: "FETCH_CONVERSATION_SUCCESS",
    FETCH_CONVERSATION_FAILURE: "FETCH_CONVERSATION_FAILURE",
    FETCH_ALL_CONVERSATIONS_REQUEST: "FETCH_ALL_CONVERSATIONS_REQUEST",
    FETCH_ALL_CONVERSATIONS_SUCCESS: "FETCH_ALL_CONVERSATIONS_SUCCESS",
    FETCH_ALL_CONVERSATIONS_FAILURE: "FETCH_ALL_CONVERSATIONS_FAILURE",
    SEND_AI_CHAT_REQUEST: "SEND_AI_CHAT_REQUEST",
    SEND_AI_CHAT_SUCCESS: "SEND_AI_CHAT_SUCCESS",
    SEND_AI_CHAT_FAILURE: "SEND_AI_CHAT_FAILURE",
    UPDATE_CHAT_DATA_REQUEST: "UPDATE_CHAT_DATA_REQUEST",
    UPDATE_CHAT_DATA_SUCCESS: "UPDATE_CHAT_DATA_SUCCESS",
    UPDATE_CHAT_DATA_FAILURE: "UPDATE_CHAT_DATA_FAILURE",
    FETCH_CHAT_THREAD_REQUEST: "FETCH_CHAT_THREAD_REQUEST",
    FETCH_CHAT_THREAD_SUCCESS: "FETCH_CHAT_THREAD_SUCCESS",
    FETCH_CHAT_THREAD_FAILURE: "FETCH_CHAT_THREAD_FAILURE",
    UPDATE_CONVERSATION_REQUEST: "UPDATE_CONVERSATION_REQUEST",
    UPDATE_CONVERSATION_SUCCESS: "UPDATE_CONVERSATION_SUCCESS",
    UPDATE_CONVERSATION_FAILURE: "UPDATE_CONVERSATION_FAILURE",
    CREATE_FORECAST_REQUEST: "CREATE_FORECAST_REQUEST",
    CREATE_FORECAST_SUCCESS: "CREATE_FORECAST_SUCCESS",
    CREATE_FORECAST_FAILURE: "CREATE_FORECAST_FAILURE",
    DELETE_CONVERSATION_REQUEST: "DELETE_CONVERSATION_REQUEST",
    DELETE_CONVERSATION_SUCCESS: "DELETE_CONVERSATION_SUCCESS",
    DELETE_CONVERSATION_FAILURE: "DELETE_CONVERSATION_FAILURE",
    GET_SALES_TARGET_FORECAST_REQUEST: "GET_SALES_TARGET_FORECAST_REQUEST",
    GET_SALES_TARGET_FORECAST_SUCCESS: "GET_SALES_TARGET_FORECAST_SUCCESS",
    GET_SALES_TARGET_FORECAST_FAILURE: "GET_SALES_TARGET_FORECAST_FAILURE",
    SAVE_TARGET_FORECAST_REQUEST: "SAVE_TARGET_FORECAST_REQUEST",
    SAVE_TARGET_FORECAST_SUCCESS: "SAVE_TARGET_FORECAST_SUCCESS",
    SAVE_TARGET_FORECAST_FAILURE: "SAVE_TARGET_FORECAST_FAILURE",
    UPDATE_THREAD_ID: "UPDATE_THREAD_ID",
    UPDATE_AGENT_TYPE: "UPDATE_AGENT_TYPE",
};
